import { Link } from "react-router-dom";
import MarriageAndParentingLogo from '../assets/marriageandparenting (2).svg';

export default function Footer() {
  return (
    <footer className="bg-white border border-border rounded-2xl p-8 mt-1">
      <div className="grid grid-cols-[240px_1fr] gap-8 mb-6 max-[680px]:grid-cols-1">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2.5 mb-3.5">
            <div className="w-10 h-10">
              <img src={MarriageAndParentingLogo} />
            </div>
            <div>
              <div className="font-display text-base font-semibold text-primary-dark leading-tight">MA &amp; PA Program</div>
              <div className="text-[10px] text-[#999] tracking-[0.08em] uppercase">MArriage &amp; PArenting</div>
            </div>
          </div>
          <div className="text-xs text-[#666] leading-[1.7]">
            <p className="mb-1.5">2015 S. Tuttle Ave #D<br />Sarasota, FL 34239</p>
            <p className="mb-1.5">Toll-free: 1-888-390-1119<br />Tel: 941-953-9556</p>
            <p><a href="mailto:info@nurturingfathers.com" className="text-primary no-underline hover:underline">info@marriageandparenting.com</a></p>
          </div>
        </div>

        {/* Links */}
        <div className="grid grid-cols-[120px_120px_1fr] gap-6 max-[680px]:grid-cols-1">
          <div className="flex flex-col gap-1.5">
            <div className="text-[10px] font-medium uppercase tracking-[0.1em] text-[#bbb] mb-1">Site</div>
            <Link to="/" className="text-xs text-[#555] no-underline hover:text-primary">Home</Link>
            <Link to="/about" className="text-xs text-[#555] no-underline hover:text-primary">About</Link>
            <Link to="/news" className="text-xs text-[#555] no-underline hover:text-primary">News</Link>
            <Link to="/consultants" className="text-xs text-[#555] no-underline hover:text-primary">Consultants</Link>
            <Link to="/contact" className="text-xs text-[#555] no-underline hover:text-primary">Contact</Link>
            <Link to="/order-form" className="text-xs text-[#555] no-underline hover:text-primary">Order Now</Link>
          </div>
          <div className="flex flex-col gap-1.5">
            <div className="text-[10px] font-medium uppercase tracking-[0.1em] text-[#bbb] mb-1">Links</div>
            <a href="https://www.nurturingfathers.com" target="_blank" rel="noopener noreferrer" className="text-xs text-[#555] no-underline hover:text-primary">Nurturing Fathers</a>
            <a href="https://www.headstart.gov" target="_blank" rel="noopener noreferrer" className="text-xs text-[#555] no-underline hover:text-primary">Head Start</a>
          </div>
          <div className="flex flex-col gap-1.5">
            <div className="text-[10px] font-medium uppercase tracking-[0.1em] text-[#bbb] mb-1">What Parents Say</div>
            <p className="text-[11px] text-[#888] leading-relaxed mb-1.5">"The lessons that I have learned in this class are precious to me and I am blessed just to be here." <em className="text-[#8A72C2] not-italic">— Wife and mother, Head Start Program</em></p>
            <p className="text-[11px] text-[#888] leading-relaxed">"Should be offered to couples planning to be married. Every married couple should consider it." <em className="text-[#8A72C2] not-italic">— Wife and mother, Baptist Church</em></p>
          </div>
        </div>
      </div>
      <div className="flex justify-between border-t border-border pt-4 text-[11px] text-[#aaa]">
        <span>Center for Growth &amp; Development, Inc. &copy; {new Date().getFullYear()}</span>
        <span>marriageandparenting.com</span>
      </div>
    </footer>
  );
}
